export * from './dienstplanEintrag2';
export * from './dienstplanFunktionsbereich2';
export * from './problemDetails';
export * from './telefonbuchEintrag2';
